export default __webpack_public_path__ + "static/media/undo.4abfdef2.svg";